import { useNavigate } from 'react-router-dom';
import { Box, SxProps } from '@mui/material';
import { Button } from 'system/atoms';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const container: SxProps = {
  mt: 4
};

const style: SxProps = {
  p: 0
};

type Props = {
  goTo?: string;
  onClick?: () => void;
  containerStyle?: SxProps;
};

/**
 * @deprecated Use `BackButton` from `common/ui` instead.
 */
export const BackButton: React.FC<Props> = ({
  goTo,
  onClick,
  containerStyle
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onClick) {
      onClick();
      return;
    }

    if (goTo) {
      navigate(goTo);
      return;
    }

    navigate(-1);
  };

  return (
    <Box
      sx={{
        ...container,
        ...containerStyle
      }}
    >
      <Button
        onClick={handleBack}
        variant="tertiary"
        sx={style}
        startIcon={<ArrowBackIcon />}
      >
        Back
      </Button>
    </Box>
  );
};
